import React, { Suspense } from "react";
import { ManualPostulationFormPage } from "@rankmi/ats-app";
import { SelectionProcessesService } from "../../../../src/core/services/selection_processes_service";

const ManualPostulationFormApplicant = ({
  token,
  tenantId,
  validateDocument,
  processId,
  geniusActivation
}) => {
  const selectionProcessService = new SelectionProcessesService();

  return (
    <Suspense fallback="">
      <ManualPostulationFormPage
        token={token}
        tenantId={tenantId}
        selectionProcessService={selectionProcessService}
        validateDocument={validateDocument}
        processId={processId}
        geniusActivation={geniusActivation}
      />
    </Suspense>
  );
};

export default ManualPostulationFormApplicant;
